exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1D_Nn{position:relative;background-color:#fff;z-index:7;padding:0 15px}._1ediK{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._1ediK,._2cKE_,.TpfX0{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.TpfX0{display:-webkit-box;display:-ms-flexbox;display:flex;text-align:right;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-right:10px;height:44px;line-height:42px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._3YhcH{border:0;background:none}._3c7Db,._3YhcH,.vuYGG{display:inline-block}.vuYGG{font-weight:600;color:inherit;text-decoration:none}.vuYGG+.vuYGG{margin-left:30px}._3c7Db{margin-left:28px}._1dKSE{color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "_1D_Nn",
	"container": "_1ediK container",
	"left": "_2cKE_",
	"right": "TpfX0",
	"locationSelect": "_3YhcH",
	"tariff": "vuYGG",
	"balance": "_3c7Db",
	"nonActiveTariff": "_1dKSE"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/SubHeader/SubHeader.css
// module id = 1374
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46